import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import { ApiContext } from 'utils/networking/Api.context';
import { notification } from 'antd';
export default function useS3UserHook() {
  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    sshKey: '',
    ips: [],
    removedIps: [],
    invalidIps: [],
    isUserCreated: false,
    createUserModalVisible: false,
  });

  useEffect(() => {
    actions.loadS3UserConfig();
  }, [appState.selectedHotel]);

  const actions = {
    async loadS3UserConfig() {
      try {
        updateState({ isLoading: true });

        const res = await API.getPoliceS3UserConfig({
          hotelId: getSelectedHotel()?.key,
        });

        if (!res) {
          updateState({
            isUserCreated: false,
            sshKey: '',
            ips: [],
            isLoading: false,
          });
          return;
        }

        updateState({
          isUserCreated: true,
          sshKey: res.sshKey || '',
          ips: res.ips || [],
          isLoading: false,
        });
      } catch (err) {
        console.error('Error loading S3 User Config:', err);
        updateState({ isUserCreated: false, isLoading: false });
      }
    },

    setField(fieldKey, value) {
      updateState({ [fieldKey]: value });
    },

    async saveS3UserConfig() {
      try {
        updateState({ isLoading: true });

        const body = {
          hotelId: getSelectedHotel()?.key,
          sshKey: state.sshKey,
          ips: state.ips,
        };

        await API.createPoliceS3User(body);
        notification.success({ message: translate('policeReport.s3UserConfig.success') });

        updateState({ isLoading: false });
      } catch (err) {
        notification.error({ message: translate('policeReport.s3UserConfig.error') });

        updateState({ isLoading: false });
      }
    },

    setModal(modalKey, value) {
      updateState({ [modalKey]: value });
    },
  };

  function updateState(updates) {
    setState(prev => ({ ...prev, ...updates }));
  }

  return { state, actions };
}
